import { ThemeConfig } from 'antd';

import colors from './colors';

const antdTheme: ThemeConfig = {
  token: {
    fontFamily: 'inherit',
    colorPrimary: colors.primary,
    colorLink: colors.primary,
    colorSplit: colors.grayLight,
    borderRadius: 6,
    colorBgContainer: 'transparent',
    colorError: colors.riskRed,
    colorSuccess: colors.riskGreen,
    colorWarning: colors.riskOrange,
    colorIcon: colors.gray,
    colorIconHover: colors.primary,
  },
  components: {
    Tabs: {
      lineWidth: 3,
      lineWidthBold: 3,
      fontWeightStrong: 600,
      horizontalItemGutter: 32,
      horizontalItemPadding: '0 0 1.2rem 0',
      horizontalItemPaddingLG: '0 1.5rem 1.2rem 1.5rem',
      horizontalMargin: '0 0 3.2rem 0',
      titleFontSize: 16,
      titleFontSizeLG: 20,
      colorBorder: colors.grayLight,
      itemColor: colors.gray,
      itemSelectedColor: colors.primary,
      itemHoverColor: colors.primary,
    },
    Table: {
      headerBg: 'transparent',
      headerSplitColor: 'transparent',
      headerFilterHoverBg: 'transparent',
      headerSortHoverBg: colors.grayUltra,
      headerSortActiveBg: colors.grayUltra,
      borderColor: colors.grayLight,
      headerColor: colors.gray,
      rowHoverBg: colors.grayUltra,
      rowExpandedBg: 'transparent',
      borderRadius: 6,
    },
    Tag: {
      defaultBg: colors.grayLight,
    },
    Input: {
      fontSize: 14,
      inputFontSize: 14,
      borderRadius: 8,
      colorBgContainer: '#fff',
    },
    Radio: {
      colorBgContainer: '#fff',
    },
  },
};

export default antdTheme;
